import axios from 'axios';
import { getGtagClientId } from './gtagService';

const API_BASE_URL = 'https://webapi.tcrypto.uz/';
const NEWS_API_BASE_URL = 'https://api.tcrypto.uz/api/v1/';

const PROD_BOT_ID = 8296403617;
const CAT_GIRL_BOT_ID = 7342037359;

const CAT_GIRL_DATA = "user=%7B%22id%22%3A279058397%2C%22first_name%22%3A%22Vladislav%20%2B%20-%20%3F%20%5C%2F%22%2C%22last_name%22%3A%22Kibenko%22%2C%22username%22%3A%22vdkfrost%22%2C%22language_code%22%3A%22ru%22%2C%22is_premium%22%3Atrue%2C%22allows_write_to_pm%22%3Atrue%2C%22photo_url%22%3A%22https%3A%5C%2F%5C%2Ft.me%5C%2Fi%5C%2Fuserpic%5C%2F320%5C%2F4FPEE4tmP3ATHa57u6MqTDih13LTOiMoKoLDRG4PnSA.svg%22%7D&chat_instance=8134722200314281151&chat_type=private&auth_date=1733584787&hash=2174df5b000556d044f3f020384e879c8efcab55ddea2ced4eb752e93e7080d6&signature=zL-ucjNyREiHDE8aihFwpfR9aggP2xiAo3NSpfe-p7IbCisNlDKlo7Kb6G4D0Ao2mBrSgEk4maLSdv6MLIlADQ";

const finalInitData = () => {
  if (window.Telegram?.WebApp.initData)
    return window.Telegram?.WebApp.initData

  if (process.env.NODE_ENV === "development") {
    return CAT_GIRL_DATA
  }
  window.location.href = "https://t.me/tcrypto_wallet_bot";
  return "err"
};

const finalBotId = () => {
  return finalInitData() === CAT_GIRL_DATA ? CAT_GIRL_BOT_ID : PROD_BOT_ID;
};


const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const messageApi = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

const fetchingAlerts = new Set();

const fetchAlert = async (eventType) => {
  if (fetchingAlerts.has(eventType)) return;

  fetchingAlerts.add(eventType);

  try {
    const res = await messageApi.post('/webapp/get_alert', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      type: eventType,
    });

    if (res.status === 200 && res.data?.title) {
      window.dispatchEvent(
        new CustomEvent('global-message', {
          detail: {
            title: res.data.title,
            content: res.data.content,
          },
        })
      );
    }
  } catch (e) {
    //тихо игнорим
  } finally {
    fetchingAlerts.delete(eventType);
  }
};

// Список event_type, которые можно триггерить вручную из компонентов
export const ALERT_EVENTS = {
  BASE_LOAD_DONE: 'BASE_LOAD_DONE',
  CARD_VIEW_OPEN: 'CARD_VIEW_OPEN',
  SELL_VIEW_OPEN: 'SELL_VIEW_OPEN',
  CABINET_ENTER_INIT: 'CABINET_ENTER_INIT',
  WALLET_ADD_INIT: 'WALLET_ADD_INIT',
};

export const alertAPI = {
  trigger: (eventType) => fetchAlert(eventType),
};

const ALERT_EVENT_MAP = [
  {
    match: (url) => url.includes('make_login_confirm'),
    event: 'CABINET_ENTER_DONE',
  },
  {
    match: (url) => url.includes('make_register_init'),
    event: 'REGISTRATION_INIT',
  },
  {
    match: (url) => url.includes('make_register_confirm'),
    event: 'REGISTRATION_DONE',
  },
  {
    match: (url) => url.includes('make_buy_usdt_init'),
    event: 'BUY_INIT',
  },
  {
    match: (url) => url.includes('make_buy_usdt_confirm'),
    event: 'BUY_DONE',
  },
  {
    match: (url) => url.includes('make_sell_usdt_init'),
    event: 'SELL_INIT',
  },
  {
    match: (url) => url.includes('make_sell_usdt_confirm'),
    event: 'SELL_DONE',
  },
  {
    match: (url) => url.includes('add_card_init'),
    event: 'CARD_ADD_INIT',
  },
  {
    match: (url) => url.includes('add_card_confirm'),
    event: 'CARD_ADD_DONE',
  },
  {
    match: (url) => url.includes('add_wallet'),
    event: 'WALLET_ADD_DONE',
  },
];

api.interceptors.response.use(
  async (response) => {
    try {
      const url = response.config.url;

      const matched = ALERT_EVENT_MAP.find((item) =>
        item.match(url)
      );

      if (matched) {
        fetchAlert(matched.event);
      }

    } catch (e) {
      console.error('alert interceptor error:', e);
    }

    return response;
  },
  (error) => Promise.reject(error)
);

api.interceptors.request.use(async (config) => {
  const gtag_id = await getGtagClientId();

  if (gtag_id) {
    if (!config.data) {
      config.data = {};
    }

    config.data.gtag_id = gtag_id;
  }

  return config;
});

const newsApi = axios.create({
  baseURL: NEWS_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});


export const authAPI = {
  // Проверка init_data для тестирования
  checkInitData: () =>
    api.post('/webapp/check_init_data', {
      init_data: finalInitData()
    }),

  // Вход в систему
  makeLoginConfirm: (phone, otp, lang = "ru") =>
    api.post('/webapp/make_login_confirm', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      phone,
      otp,
      lang,
    }),

  makeLoginInit: (phone) =>
    api.post('/webapp/make_login_init', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      phone,
    }),

  // Регистрация
  makeRegisterConfirm: (registrationData, lang = "ru") => {
    // WARNING THIS IS FOR PURPOSE BECAUSE JS IS SON OF A BITCH
    const fullPayload = {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      lang: lang,
      ...registrationData
    };
    return api.post('/webapp/make_register_confirm', fullPayload);
  },

  makeRegisterInit: (phone) =>
    api.post('/webapp/make_register_init', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      phone,
    }),

  // Получение текущего соглашения
  getCurrentAgreement: () =>
    api.post('/webapp/get_current_agreement', {
      bot_id: finalBotId(),
      init_data: finalInitData()
    }),

  // Изменение PIN-кода (обычное, без OTP)
  changePincode: (new_pin, old_pin) =>
    api.post('/webapp/change_pincode', {
      bot_id: finalBotId(),
      new_pin,
      old_pin,
      init_data: finalInitData()
    }),

  // Изменение PIN-кода с OTP подтверждением
  changePincodeWithOTP: (new_pin, otp, old_pin) =>
    api.post('/webapp/change_pincode_with_otp', {
      bot_id: finalBotId(),
      new_pin,
      old_pin,
      otp,
      init_data: finalInitData()
    }),

  // Проверка существования Telegram аккаунта
  checkTelegramExist: () =>
    api.post('/webapp/check_telegram_exists', {
      bot_id: finalBotId(),
      init_data: finalInitData()
    }),

  // Заблокировать аккаунт
  makeForbid: () =>
    api.post('/webapp/make_forbid', {
      bot_id: finalBotId(),
      init_data: finalInitData()
    }),

  // Получение ссылки для верификации
  getVerify: () =>
    api.post('/webapp/get_verify', {
      bot_id: finalBotId(),
      init_data: finalInitData()
    })
};

// API обмена валют
export const exchangeAPI = {
  calculateExchange: (type, amount) =>
    api.post('/webapp/make_calc', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      usdt_amount: amount,
      operation: type,
    }),
};

export const newsAPI = {
  getNews: (page, size, lang = 'RUS') =>
    newsApi.post('/news/list', {
      paging: {
        page: page,
        size: size,
      }
    },
      {
        headers: { 'X-Lang': lang },
      }
    ),
};

export const cardAndWalletAPI = {
  RemoveWallet: (wallet_id) =>
    api.post('/webapp/remove_wallet', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      id: wallet_id
    }),

  AddWallet: (wallet_address, wallet_name) =>
    api.post('/webapp/add_wallet', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      address: wallet_address,
      name: wallet_name
    }),

  AddCardInit: (card_pan, expiry, holder_name) =>
    api.post('/webapp/add_card_init', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      expiry: expiry,
      pan: card_pan,
      name: holder_name,
    }),

  AddCardOTP: (otp_code) =>
    api.post('/webapp/add_card_confirm', {
      bank_otp: otp_code,
      bot_id: finalBotId(),
      init_data: finalInitData(),
    }),

  RemoveCard: (card_id) =>
    api.post('/webapp/remove_card', {
      id: card_id,
      bot_id: finalBotId(),
      init_data: finalInitData(),
    }),
}

// API пользователя
export const userAPI = {
  getUserInfo: () =>
    api.post('/webapp/get_user_info', {
      bot_id: finalBotId(),
      init_data: finalInitData()
    }),

  resetPincodeInit: () =>
    api.post('/webapp/reset_pincode_init', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
    }),

  resetPincodeConfirm: (otp) =>
    api.post('/webapp/reset_pincode_confirm', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      otp: Number(otp),
    }),

  changeUserLang: (lang) =>
    api.post('/webapp/change_user_lang', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      lang: lang,
    }),

  getOfdReceipt: (transaction_id) =>
    api.post('/webapp/get_payment_ofd', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      transaction_id: transaction_id
    }),
};

// API платежей
export const paymentAPI = {
  MakeBuyUsdtInit: (card_id, usdt_amount, wallet_id, is_quick = true) =>
    api.post('/webapp/make_buy_usdt_init', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      card_id: card_id,
      is_quick: is_quick,
      usdt_amount: Number(usdt_amount.replace(/,/g, '')),
      wallet_id: wallet_id
    }),

  MakeSellUsdtInit: (card_id, tx_hash, usdt_amount, is_quick = true) =>
    api.post('/webapp/make_sell_usdt_init', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      tx_hash: tx_hash,
      card_id: card_id,
      is_quick: is_quick,
      usdt_amount: Number(usdt_amount.replace(/,/g, '')),
    }),

  MakeBuyUsdtConfirm: (otp) =>
    api.post('/webapp/make_buy_usdt_confirm', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      otp: otp,
    }),

  MakeSellUsdtConfirm: (otp) =>
    api.post('/webapp/make_sell_usdt_confirm', {
      bot_id: finalBotId(),
      init_data: finalInitData(),
      otp: Number(otp),
    }),
};

// Универсальный обработчик ошибок
export const handleApiError = (error) => {
  if (error.response) {
    const { status, data } = error.response;

    switch (status) {
      case 400:
        return data.message || 'Неверные данные запроса';
      case 401:
        return 'Необходима авторизация';
      case 403:
        return 'Недостаточно прав доступа';
      case 404:
        return 'Ресурс не найден';
      case 429:
        return 'Превышен лимит запросов. Попробуйте позже';
      case 500:
        return 'Внутренняя ошибка сервера';
      default:
        return data.message || `Ошибка ${status}`;
    }
  } else if (error.request) {
    return 'Ошибка сети. Проверьте подключение к интернету';
  } else {
    return 'Ошибка при выполнении запроса';
  }
};

export default api;